import React from 'react';
import '../../CSS/layout/Header.css';
import logo from "../../resource/water_logo(black).png"

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-logo">
                    <img src={logo}/>
                </div>
                <br/>
                <div>
                    <div className="footer-info">
                        <b><a href="#" target="_blank" rel="noopener noreferrer">이용약관</a></b>|
                        <b><a href="#" target="_blank" rel="noopener noreferrer">개인정보처리방침</a></b>|
                        <b><a href="#" target="_blank" rel="noopener noreferrer">FAQ</a></b>
                    </div>
                    <p className="footer-info2">
                        물조은펜션 : 대표자 윤정아<br/>
                        사업자등록번호 : 365-30-01621<br/>
                        농어촌민박사업자 지정번호 : 죽장 제2016-02호<br/>
                        주소 : 경상북도 포항시 북구 죽장면 죽장로 2900<br/>
                        계좌번호 : 농협 717096-52-186664(윤정아)<br/>
                        전화번호 : 010-2180-7979
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
